// src/firebase/config.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC1D2mc8eMuogYZl1v-IG_LQEvPMDCcBng",
  authDomain: "smtd-a6425.firebaseapp.com",
  databaseURL: "https://smtd-a6425-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "smtd-a6425",
  storageBucket: "smtd-a6425.firebasestorage.app",
  messagingSenderId: "499055690074",
  appId: "1:499055690074:web:a51ad19204fbd7355db363"
};

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const auth = getAuth(app);

// Création et configuration du provider Google
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

// Liste des emails administrateurs
export const ADMIN_EMAILS = [
  
  
  'smtdtrans@gmail.com'
  
];

// Liste des UID administrateurs
export const ADMIN_UIDS = [
  'LXpruq9objeN2gK0EIyidnM4DR62'
];

// Fonction utilitaire pour vérifier si un utilisateur est admin
export const isAdmin = (user) => {
  if (!user) return false;
  return ADMIN_EMAILS.includes(user.email) || ADMIN_UIDS.includes(user.uid);
};

export default app;